import { Feature } from '@tencent/workbench';
import BaseMobileContextMenuFeature from '@framework/workbench/common/feature/base-mobile-context-feature';
import { config } from './config';
import { RegionType } from '@src/slide/domain/selection/constant/region';

declare global {
    interface Window {
        isEditing: boolean;
    }
}

@Feature()
export class CopyFeature extends BaseMobileContextMenuFeature {
    id = config.name;

    public copy() {
        const { lastMouseDownRegion } = this.getSelectionService();
        switch (lastMouseDownRegion) {
            case RegionType.EDITOR:
                this.copyElement();
                break;
            case RegionType.SLIDELIST:
                this.copySlide();
                break;
            default:
                this.copyElement();
        }
    }

    /**
     * 复制元素、文字
     * @private
     */
    private async copyElement() {
        const copyPaste = await this.getAppServices().editableServiceLayer?.copyPasteManager?.promise();
        if (this.editorInstance?.isEditing) {
            // 这个库只支持真机，chrome f12模拟会报错
            copyPaste?.copyForMobile();
            return;
        }

        copyPaste?.triggerCopyEvent();
    }

    /**
     * 复制幻灯片
     * @private
     */
    private copySlide() {
        const { isEditing } = window;
        if (isEditing) {
            return;
        }
        this.getAppServices().editableServiceLayer?.copyPasteManager?.promise().then((copyPasteManager) => {
            copyPasteManager.triggerCopyEvent();
        });
    }
}
